import isEmpty from 'lodash.isempty';
import { apiHost, tpApiHost } from '../config/const';

function getAPIToken() {
  const rawCookie = document.cookie || '';
  const cookie = rawCookie.split(';').reduce((a, b) => {
    const [key, value] = b.split('=').map((str) => str.trim());
    a[key] = value;
    return a;
  }, {});
  return cookie['tappieApiToken'] || '';
}

export const header = {
  'Content-Type': 'application/json',
};

export const tokenHeader = {
  ...header,
  'tappie-api-token': getAPIToken(),
};

export const accessTokenHeader = (accessToken) => ({
  ...header,
  'liff-access-token': accessToken,
});

export const idTokenHeader = (idToken = {}) => ({
  ...header,
  'tappie-id-token': idToken.token,
});

export function callTpFetch(uri, settings) {
  return handleResponse(tpApiHost, uri, settings);
}

export function callFetch(uri, settings) {
  return handleResponse(apiHost, uri, settings);
}

export function handleResponse(host, uri, settings) {
  let url = new URL(`${host}${uri}`);
  if (!isEmpty(settings.query)) {
    Object.entries(settings.query).forEach(([key, value]) =>
      url.searchParams.set(key, value),
    );
  }

  return fetch(url.toString(), settings)
    .then((response) => {
      if (response.ok) return response.json();
      return response.text().then((text) => {
        throw Error(text);
      });
    })
    .catch((error) => {
      console.error(error);
      return { err: true, message: error.message };
    });
}
